var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsubscribeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7754 14.0443C46.4336 13.6105 45.8048 13.5359 45.371 13.8778C44.9372 14.2196 44.8627 14.8483 45.2045 15.2821L46.7754 14.0443ZM39.1252 9.82181C39.593 10.1153 40.2102 9.974 40.5037 9.50616C40.7973 9.03832 40.6559 8.42113 40.1881 8.12762L39.1252 9.82181ZM45.2045 15.2821C48.3957 19.3322 50.2992 24.4426 50.2992 30H52.2992C52.2992 23.9778 50.2347 18.4345 46.7754 14.0443L45.2045 15.2821ZM50.2992 30C50.2992 43.1445 39.6438 53.7999 26.4992 53.7999V55.7999C40.7483 55.7999 52.2992 44.2491 52.2992 30H50.2992ZM26.4992 53.7999C13.3547 53.7999 2.69922 43.1445 2.69922 30H0.699219C0.699219 44.2491 12.2501 55.7999 26.4992 55.7999V53.7999ZM2.69922 30C2.69922 16.8554 13.3547 6.19995 26.4992 6.19995V4.19995C12.2501 4.19995 0.699219 15.7508 0.699219 30H2.69922ZM26.4992 6.19995C31.1398 6.19995 35.4669 7.52669 39.1252 9.82181L40.1881 8.12762C36.2204 5.63841 31.5265 4.19995 26.4992 4.19995V6.19995Z",
    fill: "#ED6868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1719 10.7791C42.7474 11.2482 43.3013 11.7432 43.8314 12.2619",
    stroke: "#ED6868",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16211 14.3459C2.55271 13.7393 2.96604 13.1483 3.40004 12.5737",
    stroke: "#ED6868",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66719 9.52228C4.28932 9.92506 4.30951 10.5579 4.71228 10.9358C5.11506 11.3137 5.7479 11.2935 6.12578 10.8907L4.66719 9.52228ZM26.4992 2.06665C27.0515 2.06665 27.4992 1.61894 27.4992 1.06665C27.4992 0.514366 27.0515 0.0666504 26.4992 0.0666504V2.06665ZM6.12578 10.8907C11.2886 5.38764 18.5569 2.06665 26.4992 2.06665V0.0666504C17.9888 0.0666504 10.1973 3.62766 4.66719 9.52228L6.12578 10.8907Z",
    fill: "#ED6868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8356 45.6541C50.445 46.2606 50.0317 46.8517 49.5977 47.4262",
    stroke: "#ED6868",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.332 50.4777C48.7099 50.0749 48.6897 49.442 48.2869 49.0642C47.8842 48.6863 47.2513 48.7065 46.8734 49.1093L48.332 50.4777ZM26.5 57.9333C25.9477 57.9333 25.5 58.381 25.5 58.9333C25.5 59.4856 25.9477 59.9333 26.5 59.9333V57.9333ZM46.8734 49.1093C41.7107 54.6123 34.4424 57.9333 26.5 57.9333V59.9333C35.0104 59.9333 42.8019 56.3723 48.332 50.4777L46.8734 49.1093Z",
    fill: "#ED6868"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 30L39.9331 37.2333L33.7331 43.4333L26.4997 36.2L19.2664 43.4333L13.0664 37.2333L20.2997 30L13.0664 22.7667L19.2664 16.5667L26.4997 23.8L33.7331 16.5667L39.9331 22.7667L32.6997 30Z",
    stroke: "#ED6868",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribeIcon);
export default __webpack_public_path__ + "static/media/unsubscribe_icon.c6e450530eb7479b4a0464d7a9e718ea.svg";
export { ForwardRef as ReactComponent };